import { Typography } from "@mui/material"
import { Box } from "@mui/system"
import { useCardHolderContext } from "layouts/card-holder/context/useCardHolderContext.ts"
import { CardHolderPopups } from "layouts/card-holder/popups/cardHolderPopups.tsx"
import { CardHolderTable } from "layouts/card-holder/table/cardHolderTable.tsx"
import { DataStateHandler } from "components/DataStateHandler.tsx"

export const DriversContainer = () => {
    const { apiSuccess, isLoading, noResultFilter } = useCardHolderContext()

    return (
        <Box>
            <DataStateHandler
                isLoading={isLoading}
                apiSuccess={apiSuccess}
                noResultFilter={noResultFilter}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "1.5rem",
                    }}
                >
                    <Typography
                        variant="headlineLarge"
                        sx={{ color: "grey.900" }}
                    >
                        Liste des conducteurs
                    </Typography>

                    <CardHolderTable />
                </Box>
            </DataStateHandler>
            <CardHolderPopups />
        </Box>
    )
}
